"use client"

import BlockWrapper from "@/ui/common/BlockWrapper"
import { replaceRichTextLinks } from "@/utils/replaceRichTextLinks"
import { extractBlockProperties } from "@/utils/simplifyData"
import { Fragment } from "react"
import {
  CommitteeCard,
  CommitteeDescription,
  CommitteeMembers,
  CommitteeName,
  CommitteesContainer,
  CommitteesGrid,
  Divider,
  ItemsContainer,
  MemberItem,
  MemberName,
  MemberRole,
  Title,
  TopCard,
} from "./styles"

interface CardsFiltersBlockProps {
  data: any
  id?: string
}

const CardsFiltersBlock = ({ data, id }: CardsFiltersBlockProps) => {
  const topComponent = extractBlockProperties(data.topComponent.blocks)
  const lowComponent = extractBlockProperties(data.lowComponent.blocks)

  return (
    <BlockWrapper id={id}>
      {/* Top Component - Board Members */}
      <TopCard>
        <Title variant="h4" component="h2">
          {topComponent[0]?.title}
        </Title>
        <ItemsContainer>
          {topComponent[0]?.itemsList?.map((item: any, index: number) => (
            <Fragment key={`board-member-${index}`}>
              <MemberItem>
                <MemberName variant="body1">{item.fullName}</MemberName>
                <MemberRole variant="body1">{item.role}</MemberRole>
              </MemberItem>
              {index < topComponent[0].itemsList.length - 1 && <Divider />}
            </Fragment>
          ))}
        </ItemsContainer>
      </TopCard>

      {/* Bottom Component - Committees */}
      <CommitteesContainer>
        <Title variant="h4" component="h2">
          {lowComponent[0]?.title}
        </Title>
        <CommitteesGrid>
          {lowComponent[0]?.lowItemsList?.map(
            (committee: any, index: number) => (
              <CommitteeCard key={`committee-${index}`}>
                <CommitteeName variant="h5" component="h3">
                  {committee.committeeName}
                </CommitteeName>
                <CommitteeDescription variant="body1">
                  {committee.description}
                </CommitteeDescription>
                <CommitteeMembers
                  dangerouslySetInnerHTML={{
                    __html: replaceRichTextLinks(committee.committeeMembers),
                  }}
                />
              </CommitteeCard>
            ),
          )}
        </CommitteesGrid>
      </CommitteesContainer>
    </BlockWrapper>
  )
}

export default CardsFiltersBlock
